import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import Header from '../../components/features/login/Header';
import PasswordInput from '../../components/common/PasswordInput';
import apiService from '../../services/api';
import { password as validatePassword, passwordRequirements } from '../../utils/validation';
import './RecuperacaoSenha.css';

export default function RedefinirSenha() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [newPassword, setNewPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState(token ? '' : 'O link de redefinição é inválido.');

  const handleSubmit = async (event) => {
    event.preventDefault();
    const passwordError = validatePassword(newPassword);
    if (passwordError) {
      setError(passwordError);
      return;
    }
    if (newPassword !== confirmation) {
      setError('A confirmação da senha não confere.');
      return;
    }

    setLoading(true);
    setError('');
    try {
      const response = await apiService.redefinirSenha(token, newPassword, confirmation);
      setMessage(response.message);
      setNewPassword('');
      setConfirmation('');
    } catch (requestError) {
      setError(requestError.message || 'Não foi possível redefinir a senha.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="password-recovery-page">
      <Header />
      <section className="password-recovery-panel" aria-labelledby="reset-title">
        <h1 id="reset-title">Definir nova senha</h1>
        <p className="password-recovery-intro">Crie uma nova senha para acessar sua conta.</p>
        {message && <div className="password-recovery-message" role="status">{message}</div>}
        {error && <div className="password-recovery-message error" role="alert">{error}</div>}
        {!message && token && (
          <form onSubmit={handleSubmit} noValidate>
            <div className="password-recovery-field">
              <label htmlFor="new-password">Nova senha</label>
              <PasswordInput inputAs="input" className="password-recovery-password" id="new-password" name="newPassword" autoComplete="new-password" maxLength={128} value={newPassword} onChange={(event) => setNewPassword(event.target.value)} disabled={loading} required />
            </div>
            <div className="password-recovery-field">
              <label htmlFor="password-confirmation">Confirmar nova senha</label>
              <PasswordInput inputAs="input" className="password-recovery-password" id="password-confirmation" name="confirmation" autoComplete="new-password" maxLength={128} value={confirmation} onChange={(event) => setConfirmation(event.target.value)} disabled={loading} required />
            </div>
            <p className="password-recovery-requirements">{passwordRequirements}</p>
            <button className="password-recovery-submit" type="submit" disabled={loading}>{loading ? 'Alterando...' : 'Redefinir senha'}</button>
          </form>
        )}
        <Link className="password-recovery-back" to="/">Voltar ao login</Link>
      </section>
    </main>
  );
}
